import habitat from "preact-habitat";

import NCStateUtilityButton from "./components/ncstate-utility-button";
let _habitat = habitat(NCStateUtilityButton);

_habitat.render({
  selector: '#ncstate-utility-button-container',
  defaultProps: {
      color: 'red',
      searchLabel: "Search",
      topOffset: 0
  },
  clean: true
});
